const AccountSettingType = {
  NOTIFICATION: 'notification',
  FEATURE: 'feature',
} as const;

type AccountSettingType = typeof AccountSettingType[keyof typeof AccountSettingType];

export { AccountSettingType };
